const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/teams/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getTeamsQueryOptions } from '@/lib/queries/teams/useGetTeamsQuery';
import i18n from '@/lib/translations/i18n';
import { ensureNamespaceLoaded } from '@/lib/translations/i18nloader';
import type { LoaderData } from '@/lib/types/common';
const teamsSchema = z.object({
  dialog: z.enum(['import', 'create', 'sync']).optional()
});
export const Route = createFileRoute('/(app)/org/$org/teams')({
  validateSearch: zodValidator(teamsSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner,
  beforeLoad: async () => {
    await ensureNamespaceLoaded('teams');
  },
  loader: ({
    context: {
      queryClient
    }
  }): LoaderData => {
    queryClient.ensureQueryData(getTeamsQueryOptions());
    return {
      crumb: i18n.t('common.teams')
    };
  },
  staticData: {
    topNav: {
      title: i18n.t('common.teams')
    }
  }
});